import React from 'react';
import { Link } from 'react-router-dom';

import LogoColor from 'img/logo_color.png';
import ExchangeLogoColor from 'img/exchange.logo_color.png';

export default function ExternalHeader() {
  return (
    <div className="relative bg-white px-4 py-6 shadow-md sm:items-stretch sm:px-12">
      <Link to="/">
        <img
          src={process.env.REACT_APP_LOGO === 'exchange' ? ExchangeLogoColor : LogoColor}
          className="xs:h-20 mx-auto h-16 md:h-20"
          alt=""
        />
      </Link>
    </div>
  );
}
